(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    new Splide('.splide', {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      pagination: true,
      gap: '1rem',
      autoplay: true,
      pauseOnHover: true,
      arrows: false,
      breakpoints: {
        640: {
          perPage: 1,
          gap: '0.5rem',
        }
      }
    }).mount();
  });

  } catch(e) { console.error(e); }
})();
})();
